import * as d3 from 'd3'

import {
  createDomain,
  getBatchColor,
  getUniqueContourPoints
} from '@aytm/app/stats/page/question-views/hm/components/chart/lib/render/utils'

export const drawContours = (group, options) => {
  const { id, contours, levels, imageHeight, colors, opacityValues, isOnePinTypeFiltered } = options

  const domainColors = createDomain(levels.length, colors.length)
  const domainOpacity = createDomain(levels.length, opacityValues.length)

  const getColor = d3.scaleLinear().domain(domainColors).range(colors)
  const getOpacity = d3.scaleLinear().domain(domainOpacity).range(opacityValues)

  contours.forEach((item, index) => {
    const levelIndex = levels.indexOf(item.level)

    const shouldRenderLayer = isOnePinTypeFiltered ? (levels.length % 2 ? !(levelIndex % 2) : levelIndex % 2) : true

    if (!shouldRenderLayer) return

    const points = getUniqueContourPoints(item.contour, imageHeight)

    const filter =
      contours.length - 1 === index ? `url(#shadow-first-layer-filter-${id})` : `url(#shadow-layers-filter-${id})`

    group
      .append('polygon')
      .attr('points', points.map(p => p.join(',')).join(' '))
      .attr('fill', getColor(levelIndex))
      .style('opacity', getOpacity(levelIndex))
      .attr('filter', filter)
  })
}

export const drawContoursByClusters = (group, options) => {
  const { id, contours, levels, imageHeight, colors, opacityValues } = options

  const domainColors = createDomain(levels.length, colors.length)
  const domainOpacity = createDomain(levels.length, opacityValues.length)

  const getColor = d3.scaleLinear().domain(domainColors).range(colors)
  const getOpacity = d3.scaleLinear().domain(domainOpacity).range(opacityValues)

  const line = d3
    .line()
    // @ts-ignore
    .x(d => d.x)
    // @ts-ignore
    .y(d => d.y)

  contours.forEach(item => {
    // Every point is kept, repeats included. The polygons here are traced paths rather than the
    // point sets the flat contours are: a path that comes back to somewhere it has already been is
    // describing its own shape, and dropping the second visit redraws it as a different one.
    const contourPolygons = item.contour.reduce((res, point) => {
      const polygon = point.L1

      if (!res[polygon]) res[polygon] = []

      res[polygon].push({ x: point.x, y: imageHeight - point.y })

      return res
    }, {})

    // let pathData = line(contourPolygons[1]) || ''
    // Object.keys(contourPolygons).forEach(key => {
    //   if (key !== '1') pathData += ' ' + line(contourPolygons[key])
    // })

    const pathData = Object.values(contourPolygons)
      .map(polygon => line(polygon))
      .filter(Boolean)
      .join(' ')

    group
      .append('path')
      .attr('d', pathData)
      .attr('fill', getColor(levels.indexOf(item.level)))
      .style('opacity', getOpacity(levels.indexOf(item.level)))
      .attr('filter', `url(#shadow-layers-filter-${id})`)
  })
}

export const getContourStyles = (config, batches, defaultColors, defaultOpacity) => {
  const isOnePinTypeFiltered = config?.batches?.length === 1 && batches?.length > 1

  if (isOnePinTypeFiltered) {
    const batchColor = getBatchColor(config.batches[0], batches)
    return {
      colors: [batchColor, batchColor],
      opacityValues: [0.1, 1],
      isOnePinTypeFiltered
    }
  }

  return {
    colors: defaultColors,
    opacityValues: defaultOpacity,
    isOnePinTypeFiltered
  }
}
